type UnauthorizedListener = () => void;

let unauthorizedListener: UnauthorizedListener | null = null;

export function setUnauthorizedListener(listener: UnauthorizedListener): () => void {
  unauthorizedListener = listener;

  return () => {
    if (unauthorizedListener === listener) {
      unauthorizedListener = null;
    }
  };
}

export function clearUnauthorizedListener(): void {
  unauthorizedListener = null;
}

export function notifyUnauthorized(): void {
  unauthorizedListener?.();
}

export function getHttpStatus(error: unknown): number | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }

  const directStatus = (error as { status?: unknown }).status;
  if (typeof directStatus === 'number') {
    return directStatus;
  }

  const responseStatus = (error as { response?: { status?: unknown } }).response?.status;
  return typeof responseStatus === 'number' ? responseStatus : null;
}
